module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"buubletextafteraction":"Please face towards the camera, tap on the microphone button, and ask a court-related question."},"es":{"buubletextafteraction":"Por favor, diríjase hacia la cámara, presione el botón del micrófono y haga una pregunta relacionada con la corte."}}')
  delete Component.options._Ctor
}
